import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { accountId: Number }

  async sync() {
    const button = this.element
    const originalText = button.textContent
    
    try {
      button.textContent = 'Syncing...'
      button.disabled = true
      
      const response = await fetch(`/api/v1/stripe_financial_connections/sync_account/${this.accountIdValue}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      const result = await response.json()
      
      if (result.success) {
        this.showSuccess(result.message)
        // Refresh the account display after a brief delay
        setTimeout(() => window.location.reload(), 1000)
      } else {
        this.showError('Failed to sync account')
      }
    } catch (error) {
      console.error('Error syncing account:', error)
      this.showError('Failed to sync account')
    } finally {
      button.textContent = originalText
      button.disabled = false
    }
  }

  showError(message) {
    alert(`Error: ${message}`)
  }

  showSuccess(message) {
    alert(`Success: ${message}`)
  }
}